import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { ParcResultDto } from '@lexi-clients/lexi';
import { ParcListResult } from '../models/parc-list';

@Injectable({
  providedIn: 'root'
})
export class ParcListService implements IGridService<ParcResultDto> {

  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<ParcListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/Parcs/recherche-devexpress`, { params : params});
  }

  getById(id: number | string): Observable<ParcResultDto> {
    return this.http.get<any>(`${this.baseUrl}/api/Parcs/${id}`);
  }

  post(valeur: ParcResultDto): Observable<any> {
    return null;
  }

  put(valeur: ParcResultDto): Observable<any> {
    return null;
  }

  delete(valeur: ParcResultDto): Observable<any> {
    return null;
  }
}
